import { useContext, useState } from 'react'
import { AgxToast } from '@urbanx/agx-ui-components'
import { AuthContext } from '@urbanx/agx.auth.client'
import { MenuTitles, Pages } from 'constants/menu'
import { useSelectedAgency, useSelectedCampaign } from 'hooks'
import { ContentLayout, PageLayout } from 'layout'
import { AgxToastState } from 'types/commonTypes'
import PropertyDetailsSection from './PropertyDetailsSection'
import usePropertyDetailsSectionState from './usePropertyDetailsSectionState'
import PropertyInformationSubPage from '../PropertyInformationSubPage'
import { cleanFullAddress } from '@urbanx/agx.ui-components2'

const PropertyDetailsPage = () => {
  const { userAccount } = useContext(AuthContext)
  const { agency } = useSelectedAgency()
  const { campaign } = useSelectedCampaign()
  const [toastState, updateToastState] = useState<AgxToastState>({
    color: 'success',
    message: '',
    open: false,
  })
  const {
    propertyAddress,
    setPropertyAddress,
    propertyAttributes,
    hidePropertyAttributes,
    setPropertyAttributes,
    hasUnsavedChanges,
    saveState,
    isPending,
    handleSaveChanges,
    rexDisconnectedModal,
  } = usePropertyDetailsSectionState({
    campaignId: campaign?.campaignId,
    updateToastState,
  })

  return (
    <PageLayout
      agentName={userAccount?.firstName || ''}
      primaryPageTitle={agency?.name || ''}
      currentPageTitle={`Campaigns / ${cleanFullAddress(campaign?.address)}`}
      isCampaignsSection={true}
    >
      <ContentLayout
        hasSecondaryMenu={false}
        secondaryActiveMenu={MenuTitles.PROPERTY_INFORMATION}
        isCampaigns={true}
      >
        <AgxToast selector="#agxToast" toastState={toastState} />
        {!isPending && (
          <PropertyInformationSubPage
            currentPage={Pages.PROPERTY_INFORMATION_PROPERTY_DETAILS}
            isLoading={isPending}
            saveState={saveState}
            hasUnsavedChanges={hasUnsavedChanges}
            onSave={handleSaveChanges}
            saveButtonId="propertyDetailsSaveChanges"
            saveButtonTestId={`btn-propertyDetailsSaveChanges-${isPending}`}
            showChildren={!isPending}
          >
            <PropertyDetailsSection
              propertyAddress={propertyAddress}
              campaignState={campaign?.state}
              setPropertyAddress={setPropertyAddress}
              propertyAttributes={propertyAttributes}
              hidePropertyAttributes={hidePropertyAttributes}
              setPropertyAttributes={setPropertyAttributes}
              hasUnsavedChanges={hasUnsavedChanges}
            />
          </PropertyInformationSubPage>
        )}
        {rexDisconnectedModal}
      </ContentLayout>
    </PageLayout>
  )
}

export default PropertyDetailsPage
